<template>
    <div class="component__hours">
        <div class="component__hours_header">
            <component-title :size="'medium'">{{title}}</component-title>
        </div>
        <div class="component__hours_main">
            <table>
                <tbody>
                <tr
                    v-for="(item, index) in items"
                    :key="index"
                >
                    <td>{{days[index] | toCapitalize}}</td>
                    <td>
                        <template v-if="item.workFrom && item.workTo">
                            {{fromUTCTimeToLocal(item.workFrom)}} - {{fromUTCTimeToLocal(item.workTo)}}
                        </template>
                        <template v-else>
                            {{ $t('shared.components.title.NotAvailable') }}
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="component__hours_footer">
            <component-note :custom="true">{{ noteOutput }}</component-note>
        </div>
    </div>
</template>

<script>
import ComponentNote from '@/components/default/shared/ComponentNote'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import { User } from '@/User'

export default {
  name: 'component-hours',
  components: {
    ComponentTitle,
    ComponentNote
  },
  data () {
    return {
      user: new User(),
      days: [
        this.$t('forms.date.days.monday'),
        this.$t('forms.date.days.tuesday'),
        this.$t('forms.date.days.wednesday'),
        this.$t('forms.date.days.thursday'),
        this.$t('forms.date.days.friday'),
        this.$t('forms.date.days.saturday'),
        this.$t('forms.date.days.sunday')
      ]
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: [Array, Object],
      required: true
    },
    note: {
      type: String,
      default: ''
    }
  },
  computed: {
    noteOutput () {
      const ECVersion = `As event coordinator you have the permission to edit a trainers availability, please verify the above hours are correct.`
      const nonECVersion = `As event coordinators manage the availability of trainers, the hours shown above may not be a true reflection.`
      return this.user.isEventCoordinator() ? ECVersion : nonECVersion
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componenthours";
</style>
